<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">
      <div class="spacer2"></div>

      <div class="containter">
        <div class="mfhd">
          <i
            class="fa fa-angle-left"
            aria-hidden="true"
            style="padding-right: 5px; cursor: pointer"
            (click)="goBack()"
          ></i>
          User Dashboard
          <div
            class="page-description"
            style="
              color: #9c9b9b;
              font-size: 14px;
              margin-top: 8px;
              margin-bottom: 16px;
            "
          >
            Overview of memories and tags for {{ userName || 'user' }}
          </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="showErrorMsg" class="error-message">
          {{ showErrorText }}
        </div>

        <!-- Dashboard Cards -->
        <div class="dashboard-container">
          <!-- Total Memories Card - Now Clickable -->
          <div class="dashboard-card" (click)="viewAllMemories()" style="cursor: pointer;">
            <div class="card-icon memories-icon">
              <i class="fa-solid fa-brain"></i>
            </div>
            <div class="card-content">
              <div class="card-label">Total Memories</div>
              <div class="card-value">
                {{ loading ? '...' : totalMemories }}
              </div>
            </div>
          </div>

          <!-- Total Tags Card -->
          <div class="dashboard-card">
            <div class="card-icon tags-icon">
              <i class="fa-solid fa-tags"></i>
            </div>
            <div class="card-content">
              <div class="card-label">Total Tags</div>
              <div class="card-value">
                {{ loading ? '...' : totalTags }}
              </div>
            </div>
          </div>
        </div>

        <!-- Tags List Section -->
        <div class="tags-section" *ngIf="!loading && tags.length > 0">
          <h3 class="section-title">Available Tags</h3>
          <div class="tags-list">
            <span class="tag-chip" *ngFor="let tag of tags" (click)="viewMemoriesByTag(tag)" style="cursor: pointer;">
              {{ tag }}
            </span>
          </div>
        </div>

        <!-- No Data Message -->
        <div *ngIf="!loading && totalMemories === 0 && totalTags === 0" class="no-data">
          <i class="fa-solid fa-inbox" style="font-size: 48px; color: #ccc; margin-bottom: 16px;"></i>
          <p>No memories or tags found for this user.</p>
        </div>
      </div>
    </div>
  </div>
</div>